import { gql } from 'apollo-angular';

export const GET_COLLECTION_BY_HANDLE = gql`
  query GetCollectionByHandle($handle: String!) {
    collection(handle: $handle) {
      products(first: 250) {
        edges {
          node {
            id
            title
            descriptionHtml
            tags
            vendor
            handle
            totalInventory
            productType
            priceRange {
              minVariantPrice {
                amount
              }
            }
            featuredImage {
              url(transform: { maxHeight: 2000, maxWidth: 2000 })
              altText
              width
              height
              id
            }
            seo {
              title
              description
            }
            ... on Product {
              variants(first: 25) {
                edges {
                  node {
                    id
                    availableForSale
                    quantityAvailable
                    sku
                    title
                    price {
                      amount
                    }
                    weight
                    weightUnit
                    image {
                      url(transform: { maxHeight: 2000, maxWidth: 2000 })
                      altText
                      width
                      height
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_PRODUCTS_BY_KEYWORD = gql`
  query products($keyword: String!) {
    products(first:250, query: $keyword) {
      edges {
        node {
          id
          title
          descriptionHtml
          tags
          vendor
          handle
          totalInventory
          productType
          priceRange {
            minVariantPrice {
              amount
            }
          }
          featuredImage {
            url(transform: { maxHeight: 2000, maxWidth: 2000 })
            altText
            width
            height
            id
          }
          seo {
            title
            description
          }
          ... on Product {
            variants(first: 25) {
              edges {
                node {
                  id
                  availableForSale
                  quantityAvailable
                  sku
                  title
                  price {
                    amount
                  }
                  weight
                  weightUnit
                  image {
                    url(transform: { maxHeight: 2000, maxWidth: 2000 })
                    altText
                    width
                    height
                    id
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
